import { render } from "./AlbumCard.vue?vue&type=template&id=e3a00cd2&scoped=true"
import script from "./AlbumCard.vue?vue&type=script&lang=ts"
export * from "./AlbumCard.vue?vue&type=script&lang=ts"

import "./AlbumCard.vue?vue&type=style&index=0&id=e3a00cd2&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-e3a00cd2"

export default script